import PriceRange from './PriceRange';

export default PriceRange;